import api from './api.service';

function getSummary(params) {
  return api.get('/anomalies/summary', params);
}

function getBookedZero(params) {
  return api.get('/anomalies/booked-zero', params);
}

function getAssignedLoop(params) {
  return api.get('/anomalies/assigned-loop', params);
}

function getDuplicateAssignments(params) {
  return api.get('/anomalies/duplicate-assignments', params);
}

function getOrdersMissing(params) {
  return api.get('/anomalies/orders-missing', params);
}

function getSchoolMismatch(params) {
  return api.get('/anomalies/school-mismatch', params);
}

function getBookedButAvailable(params) {
  return api.get('/anomalies/booked-but-available', params);
}

function getOrphanTeachers(params) {
  return api.get('/anomalies/orphan-teachers', params);
}

function exportOrdersMissing(params) {
  return api.get('/anomalies/orders-missing/export', params);
}

function getVqtyMismatch(params) {
  return api.get('/anomalies/vqty-mismatch', params);
}

function vqtyMismatchFix(params) {
  return api.post('/anomalies/vqty-mismatch/fix', params);
}

export const anomalyService = {
  getSummary,
  getBookedZero,
  getAssignedLoop,
  getDuplicateAssignments,
  getBookedButAvailable,
  getSchoolMismatch,
  getOrdersMissing,
  getOrphanTeachers,
  exportOrdersMissing,
  getVqtyMismatch,
  vqtyMismatchFix,
};
